module.exports = __webpack_public_path__ + "img/label.b3d85c0b.svg";